import { observer } from 'mobx-react-lite';
import { SyntheticEvent, useEffect, useState } from 'react';
import {
  Segment,
  Header,
  Form,
  Select,
  Input,
  Button,
} from 'semantic-ui-react';
import { useStore } from '../../../../app/stores/store';
import sendRespectiveEmail from '../../../../app/models/EmailNew';
import agent from '../../../../app/api/agent';
import { toast } from 'react-toastify';
import { User } from '../../../../app/models/user';

function InwardAssignPickerForm() {
  const { commonStore, dashboardStore, activityStore, userStore } = useStore();
  const { userList, loadUsers } = userStore;
  const [inwardEdit, setinwardEdit] = useState({
    id: '',
    pickerName: '',
    pickerPhoneNumber: '',
    isPickerAssigned: true,
    title: '',
  });
  const [phoneNumber, setPhoneNumber] = useState<string>('');
  const [pickerEmail, setPickerEmail] = useState<string>('');
  const [userOptions, setUserOptions] = useState<any>([]);
  const [picker, setPicker] = useState<string>('');

  useEffect(() => {
    if (userList.length === 0) loadUsers();
  }, [userList.length, loadUsers]);

  useEffect(() => {
    let id = '';
    activityStore.inward.PickerAssign?.data?.forEach((localData: any) => {
      if (localData.id === activityStore.selectedActivity?.id) {
        id = localData?.inwards?.[0]?.id || '';
      }
    });
    setinwardEdit({
      ...inwardEdit,
      id,
    });
    // eslint-disable-next-line
  }, [
    activityStore.inward.PickerAssign?.data,
    activityStore.selectedActivity?.id,
  ]);

  useEffect(() => {
    setUserOptions(
      userStore.getUsers.map((x) => ({
        key: x.id,
        text: x.displayName,
        value: x.id,
      })),
    );
  }, [userStore.getUsers]);

  const handleChange = (e: SyntheticEvent, data: any) => {
    if (data.value === '') {
      setPhoneNumber('');
    } else {
      // const userdata = userRegistry.get(data.value);
      const userdata = userList.filter((u: User) => u.id === data.value)?.[0];
      if (userdata?.phoneNumber) {
        setPhoneNumber(
          userdata?.phoneNumber !== undefined ? userdata?.phoneNumber : '',
        );
        setPicker(userdata?.id !== undefined ? userdata?.id : '');
      } else {
        setPhoneNumber('');
        setPicker(userdata?.id !== undefined ? userdata?.id : '');
      }
      setPickerEmail(userdata?.email || '');
      // for Inward
      if (
        inwardEdit !== undefined &&
        dashboardStore.dashboard.valueForL3Orders === 'Picker Assign'
      ) {
        const newArr = {
          ...inwardEdit,
          pickerName:
            userdata?.displayName !== undefined ? userdata?.displayName : '',
          pickerPhoneNumber:
            userdata?.phoneNumber !== undefined ? userdata?.phoneNumber : '0',
          isPickerAssigned: true,
        };
        setinwardEdit(newArr);
      }
    }
  };

  const handleSubmit = async () => {
    try {
      if (dashboardStore.dashboard.valueForL3Orders === 'Picker Assign') {
        if (!inwardEdit.id?.length) {
          return;
        }
        let params = {
          id: inwardEdit.id,
          pickerName: inwardEdit.pickerName,
          pickerPhoneNo: phoneNumber,
        };
        let result = await agent.Inwards.inwardPickerAssignUpdate(params);
        if (result?.data) {
          commonStore.updateHistoryAlonePOST(
            `Inward asset - ${activityStore.selectedActivity?.title} is picked by ${inwardEdit.pickerName}`,
            activityStore.selectedActivity?.id,
            undefined,
            true,
            true,
          );
          dashboardStore.dashboard.valueForL3Orders = 'Move To Vault';
          toast.success('Approved Successfully');
          await agent.InventoryDelivery.OrderTrackingStatus(
            activityStore.selectedActivity?.id,
            'Inward Asset Picker Assigned',
          );
        }

        sendRespectiveEmail(
          '',
          activityStore.selectedActivity?.title || '',
          'Inward - Notification',
          '',
          '',
          pickerEmail,
          `Dear ${inwardEdit.pickerName}, <br/>\u00A0  ${activityStore.selectedActivity?.title} {${activityStore.selectedActivity?.id}} is assigned to you to pick it up to place inside the vault. <br/> <br/> Regards, <br/> ${userStore.user?.displayName}`,
        );
      }
      dashboardStore.dashboard.AssetTableAssignClicked = '';
      setPhoneNumber('');
    } catch {
      toast.error('Something went wrong');
    }
  };
  return (
    <Segment
      style={{
        height: '61.8vh',
        marginTop: '10px',
        marginBottom: '1px',
        overflowY: 'scroll',
        marginRight: '10px',
      }}
    >
      <Header
        icon="edit"
        size="huge"
        dividing
        as="h1"
        content="Authorized Personnal"
        sub
        color="grey"
      />
      <Header />
      <Header />
      {dashboardStore.dashboard.L2CardValueOrders === 'Inward' &&
      dashboardStore.dashboard.valueForL3Orders === 'Picker Assign' &&
      dashboardStore.dashboard.AssetTableAssignClicked.length !== 0 ? (
        <>
          <Form>
            <Form.Field
              id="picker_name: "
              options={userOptions}
              control={Select}
              label="Picker Name"
              placeholder="Select Picker Name"
              clearable
              onChange={handleChange}
              value={picker}
            />
            <Form.Field
              id="picker_phone: "
              //options={options}
              control={Input}
              label="Picker Phone No "
              placeholder="Picker Phone No"
              value={phoneNumber}
              onChange={(_e: any, { value }: { value: string }) =>
                setPhoneNumber(value)
              }
            />

            <Form.Field id="ReelNumber" label="" placeholder="" />
          </Form>
          <Button.Group
            style={{
              position: 'absolute',
              bottom: '5px',
              left: '5px',
            }}
          >
            <Button>Cancel</Button>

            <Button.Or />

            <Button
              type="submit"
              content="Submit"
              positive
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Button.Group>
        </>
      ) : (
        <p style={{ marginTop: '-10px' }}>Please select item received</p>
      )}
    </Segment>
  );
}

export default observer(InwardAssignPickerForm);
